export const getInitials = (fullName: string): string => {
  const words = fullName.split(" ");
  let initials = "";

  // append the first letter of each word to the initials
  for (const word of words) {
    if (word.length > 0) {
      initials += word[0].toUpperCase();
    }
  }

  return initials;
};
